// extracted by mini-css-extract-plugin
export default {"inputForm":"InputForm_inputForm__j+nvu"};